import React, {useState} from 'react';
import TextField from './components/TextField';
import Post from './components/Post';
import splash3 from './images/splash3.jpg'; // background image
import betx from './images/betx.png'; // logo image
import {FaKey, FaMobileAlt} from 'react-icons/fa';

const PostFree = () => {
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [referral, setReferral] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = setter => e => {
    setter(e.target.value);
  };

  const login = () => {
    if (!name) {
      alert('Name is required');
    } else if (!mobile) {
      alert('Mobile is required');
    } else if (!password) {
      alert('Password is required');
    } else {
      setLoading(true);
      Post.Signup({name, mobile, password, referral}).then(res => {
        setLoading(false);
        if (!res.error) {
          if (res.id) {
            window.location.href = `/otp?type=signup&id=${res.id}`;
          } else {
            alert('Successfully registered!');
            window.location.href = '/';
          }
        } else {
          alert('Error: ' + res.errorMsg);
        }
      });
    }
  };

  return (
    <>
      <style>{`
        .custominput::placeholder {
          color: white;
        }
      `}</style>
      <div style={{backgroundColor: '#E6DBBA', minHeight: '100vh'}}>
        <div style={{...styles.bg, backgroundImage: `url(${splash3})`}}>
          {loading && (
            <div style={styles.overlay}>
              <div>Please wait...</div>
            </div>
          )}
          <div style={styles.layer}>
            <div style={styles.logoContainer}>
              <img src={betx} alt="logo" style={styles.logo} />
            </div>

            <div style={styles.card}>
              <h2 style={styles.title}>CREATE ACCOUNT</h2>

              <div style={styles.inputWrapper}>
                <FaKey color="white" size={20} style={{marginRight: 10}} />
                <input
                  type="type"
                  placeholder="Name"
                  value={name}
                  className="custominput"
                  onChange={handleInputChange(setName)}
                  style={{
                    flex: 1,
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'white',
                    outline: 'none',
                  }}
                />
              </div>

              <div style={styles.inputWrapper}>
                {/* <TextField
                label="Mobile Number"
                type="number"
                maxLength="10"
                value={mobile}
                onChange={handleInputChange(setMobile)}
              /> */}
                <FaMobileAlt
                  color="white"
                  size={20}
                  style={{marginRight: 10}}
                />
                <input
                  type="number"
                  placeholder="Mobile Number"
                  className="custominput"
                  value={mobile}
                  maxLength="10"
                  onChange={handleInputChange(setMobile)}
                  style={{
                    flex: 1,
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'white',
                    outline: 'none',
                  }}
                />
              </div>

              <div style={styles.inputWrapper}>
                {/* <TextField
                label="Password"
                type="password"
                value={password}
                onChange={handleInputChange(setPassword)}
              /> */}
                <FaKey color="white" size={20} style={{marginRight: 10}} />
                <input
                  type="Password"
                  placeholder="Password"
                  className="custominput"
                  value={password}
                  onChange={handleInputChange(setPassword)}
                  style={{
                    flex: 1,
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'white',
                    outline: 'none',
                  }}
                />
              </div>

              <div style={styles.inputWrapper}>
                {/* <TextField
                label="Referral Code (optional)"
                value={referral}
                onChange={handleInputChange(setReferral)}
              /> */}
                <FaKey color="white" size={20} style={{marginRight: 10}} />
                <input
                  type="text"
                  placeholder="Referral Code (optional)"
                  className="custominput"
                  value={referral}
                  onChange={handleInputChange(setReferral)}
                  style={{
                    flex: 1,
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: 'white',
                    outline: 'none',
                  }}
                />
              </div>

              <button style={styles.loginBtn} onClick={login}>
                <span style={styles.loginBtnText}>Register</span>
              </button>

              <div style={styles.footer}>
                <span style={styles.footerText}>Already Registered?</span>
                <button
                  style={styles.linkBtn}
                  onClick={() => (window.location.href = '/')}>
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostFree;

const styles = {
  bg: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  layer: {
    width: '100%',
    maxWidth: 400,
    margin: '0 auto',
    padding: 15,
    textAlign: 'center',
  },
  logoContainer: {
    marginTop: 60,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 20,
    overflow: 'hidden',
  },
  logo: {
    height: 200,
    width: 250,
  },
  card: {
    backgroundColor: 'rgba(0,0,0,0.4)',
    borderRadius: 20,
    padding: 20,
    border: '1px solid #10C2AA',
  },
  title: {
    textAlign: 'center',
    marginBottom: 20,
    fontWeight: 'bold',
    color: 'white',
  },
  inputWrapper: {
    marginBottom: 10,
    display: 'flex',
    alignItems: 'center',
    border: '2px solid #10C2AA',
    borderRadius: 10,
    backgroundColor: 'rgba(255,255,255,0.1)',
    padding: '10px 12px',
  },
  loginBtn: {
    width: '100%',
    borderRadius: 12,
    marginTop: 25,
    padding: '14px 0',
    backgroundColor: '#0AB4A7',
    border: 'none',
    cursor: 'pointer',
  },
  loginBtnText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 18,
  },
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
  },
  footerText: {
    fontWeight: 'bold',
    color: 'white',
    marginRight: 10,
  },
  linkBtn: {
    background: 'none',
    border: 'none',
    color: 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    fontSize: 20,
    fontWeight: 'bold',
  },
};
